import { useState } from "react";

interface SettingsSection {
  id: string;
  label: string;
  content: React.ReactNode;
}

interface Props {
  sections: SettingsSection[];
  className?: string
}

export const SettingsTabs = ({ sections, className="" }: Props) => {
  const [active, setActive] = useState(sections[0].id);

  const activeSection = sections.find(s => s.id === active);

  return (
    <div className={`tw-flex tw-flex-col md:tw-flex-row tw-w-full tw-min-h-[70vh] ${className}`}>

      {/* Sidebar / Menu */}
      <aside className="tw-w-full md:tw-w-1/5 md:tw-min-w-[12rem] tw-border-b md:tw-border-b-0 md:tw-border-r tw-border-gray-200">

        {/* Mobile dropdown */}
        <div className="md:tw-hidden tw-py-4">
          <select
            className="tw-w-full tw-border tw-rounded-md tw-p-2"
            value={active}
            onChange={(e) => setActive(e.target.value)}
          >
            {sections.map(section => (
              <option key={section.id} value={section.id}>
                {section.label}
              </option>
            ))}
          </select>
        </div>

        {/* Desktop menu */}
        <ul className="tw-hidden md:tw-flex tw-flex-col tw-pr-2">
          {sections.map(section => (
            <li
              key={section.id}
              onClick={() => setActive(section.id)}
              className={`
                tw-cursor-pointer tw-px-3 tw-py-2 tw-rounded-full tw-mb-1
                ${active === section.id
                  ? "tw-border-blue-600 tw-bg-[#cdeece] tw-text-green-900 tw-font-medium"
                  : "tw-border-transparent  hover:tw-bg-gray-200 tw-transition-all"}
              `}
            >
              {section.label}
            </li>
          ))}
        </ul>
      </aside>

      {/* Content */}
      <main className="tw-w-full md:tw-w-4/5 tw-p-4 md:tw-p-0 md:tw-px-6">
        {activeSection?.content}
      </main>

    </div>
  );
};
